import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const ckeditorMixin = {
    data() {
        return {
            editorOptions: {
                editor: ClassicEditor,
                model: null,
                editorData: '',
                editorConfig: {
                    language: 'ru',
                    toolbar: [
                        'heading', '|',
                        'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
                        'alignment',
                        'bold', 'italic', 'blockQuote', '|',
                        'MathType', '|',
                        'underline', 'strikethrough',
                        'subscript', 'superscript',
                        'bulletedList',
                        'numberedList',
                        'link', 'highlight'
                    ],
                },
                tagName: 'textarea',
            },
        }
    }
}

export default ckeditorMixin;
